export interface IBusyDate {
  Date: string;
  Count: number;
}

export interface ICalendar {
  id: string;
  name: string;
  type: ECalendarType;
  color?: string;
}

export enum ECalendarType {
  None = 0,
  Nota = 1,
  CourtPortal = 2,
  Goolge = 3,
  Outlook = 4,
  Apple = 5,
}
